<!--本页为左侧下拉菜单-->
<template lang="pug">
ul.nav-list
  li.nav-item(v-for="item of menu", :class="{ active: item.permissionKey === navName }", :key="item.permissionKey", @click="clickadd(item)")
    IconSvg.nav-icon(:name="item.permissionKey")
    p.nav-label {{ item.name }}
</template>

<script>
import { mapState } from "vuex";
import requestprj from "@/CommonDP/service/integratedModel-service";
import { getMenuListApplication } from "@/CommonDP/utils/tree";
import resources from "@/CommonDP/service/admin/resources-service";
// 导入所有图标
const req = require.context("./icon-svg/", false, /\.svg$/);
req.keys().forEach(req);
export default {
  name: "NavMenu",
  computed: {
    ...mapState({
      authRoutes: (state) => state.router.authRoutes,
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    navName() {
      const {
        menu,
        $route: { matched }
      } = this;
      return matched.find(({ name }) => menu.some(({ permissionKey }) => name === permissionKey))?.name || "";
    },
    menu() {
      let meauList = [];
      if (this.authRoutes && this.authRoutes.length > 0) {
        meauList = getMenuListApplication(this.authRoutes, this.$router);
        meauList.forEach((item) => {
          if (!item.iconPath && !item.icon) {
            item.icon = resources.getResourceInActiveIconUrl(item.permissionId);
          }
        });
        return meauList;
      } else {
        return [];
      }
    }
  },
  created() {
    if (this.navName === "project") this.goprj();
  },
  methods: {
    async clickadd(item) {
      this.$emit("isshow", item);
      if (item.permissionKey === "project") {
        this.goprj();
      } else if (item.permissionKey === "message" || item.permissionKey === "application") {
        this.$router.push({ name: item.permissionKey });
      } else {
        this.$router.push(item.path);
      }
    },
    async goprj() {
      if (this.enterpriseId) {
        const params = {
          enterpriseId: this.enterpriseId,
          prjName: "",
          prjCode: "",
          prjType: "",
          prjLevel: ""
        };
        const { data } = await requestprj.queryPrj(params);
        if (data && data[0]) {
          this.$router.push({ name: "project" });
        } else {
          this.$store.dispatch("updatePrj", {
            createTime: "",
            enterPrjTime: "",
            prjCode: "",
            prjId: "",
            prjName: ""
          });
          this.$router.push({ name: "noproject" });
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$default-color: #b5bed2;
$active-color: #fff;

ul.nav-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  li.nav-item {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    cursor: pointer;
    padding: 10px 0px;
    margin-bottom: 0px;
    transition: all 0.2s;
    .nav-label {
      font-size: 12px;
      color: $default-color;
    }
    .nav-icon {
      width: 24px;
      height: 24px;
      margin: 0 0 4px;
      color: $default-color;
    }
    &:hover {
      background-color: #44576b;
    }
    &.active {
      background-color: #2c3e50;
    }
    &.active,
    &:hover {
      .nav-label,
      .nav-icon {
        color: $active-color;
      }
    }
  }
}
</style>
